// @ts-strict-ignore
import type { Option } from '@usealloy/component-library';
import type { FormState } from './types';
import type { NodeEditorFormAdapter } from '../useNodeEditorForm';
import { SERVICE_FAILURE_DEFAULT_LABELS } from './constants';
import { Operation } from 'flow/service/changelog/types';
import { createUiEffectContext } from 'flow/service/history';
import type { WorkflowHistoryContext } from 'flow/store/redux/types';
import { changeDescription } from 'flow/store/redux/types';
import { getNodeEditorFormHtmlElementId } from 'flow/editor/hooks/useWorkflowHistory/helpers';

export const TAG_LOCAL_SETTINGS_FORM_KEY = 'tag--options' as const;

export function getTagLocalSettingsFieldElementId(field: keyof FormState): string {
  return getNodeEditorFormHtmlElementId(TAG_LOCAL_SETTINGS_FORM_KEY, field);
}

const serviceFailureLabelsMappedToValues = {
  [SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW]: null,
  [SERVICE_FAILURE_DEFAULT_LABELS.APPLY_TAG]: true,
  [SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_APPLY_TAG]: false,
};

export function getServiceFailureDefaultOptions(): Option[] {
  return Object.values(SERVICE_FAILURE_DEFAULT_LABELS).map(label => ({
    label,
    value: label,
  }));
}

export function buildServiceFailureDefaultOption(value: boolean): Option {
  switch (value) {
    case true:
      return {
        label: SERVICE_FAILURE_DEFAULT_LABELS.APPLY_TAG,
        value: SERVICE_FAILURE_DEFAULT_LABELS.APPLY_TAG,
      };
    case false:
      return {
        label: SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_APPLY_TAG,
        value: SERVICE_FAILURE_DEFAULT_LABELS.DO_NOT_APPLY_TAG,
      };
    case null:
      return {
        label: SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW,
        value: SERVICE_FAILURE_DEFAULT_LABELS.EXIT_WORKFLOW,
      };
    default:
      return null;
  }
}

export const tagLocalSettingsFormAdapter: NodeEditorFormAdapter<FormState> = {
  history: {
    createContext: ({ action, field }): WorkflowHistoryContext => ({
      operation: Operation.Modify,
      uiEffectContext: createUiEffectContext(changeDescription.tagLocalSettings, {
        actionId: action.publicId,
        htmlElementId: getTagLocalSettingsFieldElementId(field as keyof FormState),
      }),
    }),
  },
  shouldSyncFormFromSource: () => true,
  getDefaultFormValues(action) {
    const { serviceFailureDefault } = action;
    return {
      serviceFailureDefaultOption: buildServiceFailureDefaultOption(serviceFailureDefault),
    };
  },
  mapFormDataToAction(data, sourceAction) {
    return {
      ...sourceAction,
      serviceFailureDefault: serviceFailureLabelsMappedToValues[
        data.serviceFailureDefaultOption.label
      ],
    };
  },
};
